<!-- <img src="../../../../../assets/dist/img/home-chart.PNG" width="100%"/> -->
<div class="chart-playground">
    <img src="{{ url }}" width="100%" />
</div>
